import { render, staticRenderFns } from "./PermissionUserRoleModal.vue?vue&type=template&id=627a2c34&scoped=true&"
import script from "./PermissionUserRoleModal.vue?vue&type=script&lang=js&"
export * from "./PermissionUserRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionUserRoleModal.vue?vue&type=style&index=0&id=627a2c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a2c34",
  null
  
)

export default component.exports